import React from "react";
import ReactDOM from "react-dom";
import { observer } from "mobx-react-lite";
import { PolotnoContainer, SidePanelWrap, WorkspaceWrap } from 'polotno';
import { Workspace } from "polotno/canvas/workspace";
import {
  SidePanel,
  SectionTab,
  LayersSection
} from "polotno/side-panel";
import { isGradient, parseColor } from "polotno/utils/gradient";
import { Toolbar } from "polotno/toolbar/toolbar";
import { ZoomButtons } from "polotno/toolbar/zoom-buttons";
import { createStore } from "polotno/model/store";
import { getImageSize } from "polotno/utils/image";
import { Tabs, Tab } from "@blueprintjs/core";
import '@blueprintjs/core/lib/css/blueprint.css';
import {
  Button,
  Navbar,
  Alignment,
} from '@blueprintjs/core';
import '@blueprintjs/core/lib/css/blueprint.css';
import styled from 'polotno/utils/styled';
import { ImagesGrid } from "polotno/side-panel/images-grid";
import { useState } from 'react';
import MdcQualityHigh from '@meronex/icons/mdc/MdcQualityHigh';
import { Adsense } from '@ctrl/react-adsense';
import { setColorsPresetFunc } from 'polotno/config';
import BiShieldQuarter from '@meronex/icons/bi/BiShieldQuarter';
import FaCrown from '@meronex/icons/fa/FaCrown';
import MdColorPalette from '@meronex/icons/ios/MdColorPalette';
import BiText from '@meronex/icons/bi/BiText';
import FaFileImport from '@meronex/icons/fa/FaFileImport';
import GiLion from '@meronex/icons/gi/GiLion';
import { Icon } from "@blueprintjs/core";
import TutorialModal from './components/TutorialModal';
import './App.css';





const store = createStore({
  // https://polotno.dev/cabinet
  key: "cWIIWTmkMgSoPVuDcMiK"
});



const DEFAULT_COLORS = ['#FFD700', '#F2F2F2', '#0300CC', '#CB0100', '#8C0099', '#222222', '#006600', '#CE956C', '#FEC3AC', '#9B4D13', '#B5B5B5', '#F27900'];

function sameColors(color1, color2) {
  return color1 === color2;
}

export const getUsedColors = (store) => {
  const colors = [];
  store.pages.forEach((page) => {
    page.children.forEach((element) => {
      if (element.type === 'text') {
        colors.push(element.fill);
      }
      if (element.type === 'svg') {
        colors.push(...Array.from(element.colorsReplace.values()));
      }
    });
  });

  const solidColors = [];
  colors.forEach((color) => {
    if (isGradient(color)) {
      const { stops } = parseColor(color);
      solidColors.push(...stops.map((stop) => stop.color));
    } else {
      solidColors.push(color);
    }
  });

  return [...new Set(solidColors.reverse())];
};

let getColorsPreset = (store) => {
  const colors = getUsedColors(store).slice(0, 40);
  const colorsWithoutDefault = colors.filter((color) => {
    const isDefault = DEFAULT_COLORS.find((c) => sameColors(c, color));
    return !isDefault;
  });

  const preset = colorsWithoutDefault.concat(
    DEFAULT_COLORS.slice(0, 40 - colorsWithoutDefault.length)
  );

  return preset;

};

setColorsPresetFunc((store) => {
  return getColorsPreset(store);
});

const AVAILABLE_SIZES = [
  { "format": "Square", "width": 1080, "height": 1080 },
  { "format": "Instagram Story / TikTok", "width": 1080, "height": 1920 },
  { "format": "Facebook Image", "width": 1200, "height": 630 },
  { "format": "Twitter Image", "width": 900, "height": 450 },
  { "format": "Pinterest", "width": 1000, "height": 1500 },
  { "format": "Tumblr", "width": 750, "height": 500 },
  { "format": "YouTube Thumbnail ", "width": 1280, "height": 720 },
  { "format": "YouTube Banner", "width": 2560, "height": 1440 }
];


const NavbarContainer = styled('div')`
  @media screen and (max-width: 500px) {
    overflow-x: auto;
    overflow-y: hidden;
    max-width: 100vw;
  }
`;

const NavInner = styled('div')`
  @media screen and (max-width: 500px) {
    display: flex;
  }
`;


store.addPage(
  { background: "white" }
);

console.log(store.activePage.children);

store.activePage.addElement({
  type: "svg",
  src: "/wp-content/coamakerbasic/coageneral/coamaker-main-logo.svg",
  height: 100,
  width: 201,
  x: 25,
  y: 960,
  name: "CoaMaker Logo",
  locked: true,
  selectable: false,
  alwaysOnTop: true,
  id: "logo"
});

store.activePage.addElement({
  type: "svg",
  src: "/wp-content/coamakerbasic/coashields/345_Shield_undivided.svg",
  height: 1000,
  width: 816,
  x: 130,
  y: 33,
  name: "Escutcheon"
});


store.activePage.addElement({
  type: "svg",
  src: "/wp-content/coamakerbasic/coageneral/563_dragonrampant.svg",
  height: 750,
  width: 630,
  x: 220,
  y: 130,
  name: "Dragon"
});

function CoaAdsense() {
  return <div className="coa-top-ad"><Adsense
    client="ca-pub-7706095824493443"
    data-ad-format="fluid"
    data-ad-layout-key="-fb+5w+4e-db+86"
    data-ad-client="ca-pub-7706095824493443"
    data-ad-slot="4392451863"
  /></div>
}



const AnimalSection = {
  name: 'animals',
  Tab: (props) => (
    <SectionTab name="Charges" {...props}>
      <GiLion />
    </SectionTab>
  ),
  // we need observer to update component automatically on any store changes
  Panel: observer(({ store }) => {
    const [images, setImages] = React.useState([]);

    async function loadImages() {
      const time = (new Date()).getTime();
      const animalUrl = "/wp-content/coamakerbasic/coa/0_coa.json?=ver";
      const animalFetch = animalUrl + time;
      fetch(animalFetch)
        .then(function (resp) {
          return resp.json();
        })
        .then(function (data) {
          setImages(data);
        });
      //setImages(data.url);
      await new Promise((resolve) => setTimeout(resolve, 3000));
    }

    React.useEffect(() => {
      loadImages();
    }, []);

    const [coaSearchTerm, setSearchTerm] = useState('');

    var aniImages = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "ani")) {
          aniImages.push(images[i]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "ani") || (image["sec"] === "pla") || (image["sec"] === "hum") || (image["sec"] === "ina"))
          )) {
          aniImages.push(images[i]);
        }
      }
    }

    var inaImages = []
    for (var j = 0; j < images.length; j++) {
      let image = images[j];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "ina")) {
          inaImages.push(images[j]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "ani") || (image["sec"] === "pla") || (image["sec"] === "hum") || (image["sec"] === "ina"))
          )) {
          inaImages.push(images[j]);
        }
      }
    }

    var humImages = []
    for (var k = 0; k < images.length; k++) {
      let image = images[k];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "hum")) {
          humImages.push(images[k]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "ani") || (image["sec"] === "pla") || (image["sec"] === "hum") || (image["sec"] === "ina"))
          )) {
          humImages.push(images[k]);
        }
      }
    }

    var plaImages = []
    for (var m = 0; m < images.length; m++) {
      let image = images[m];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "pla")) {
          plaImages.push(images[m]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "ani") || (image["sec"] === "pla") || (image["sec"] === "hum") || (image["sec"] === "ina"))
          )) {
          plaImages.push(images[m]);
        }
      }
    }

    var aniPreview = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if (coaSearchTerm === "") {
        if ((image["pro"] === true) && (image["sec"] === "ani")) {
          aniPreview.push(images[i]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === true) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "ani") || (image["sec"] === "pla") || (image["sec"] === "hum") || (image["sec"] === "ina"))
          )) {
          aniPreview.push(images[i]);
        }
      }
    }

    var inaPreview = []
    for (var j = 0; j < images.length; j++) {
      let image = images[j];
      if (coaSearchTerm === "") {
        if ((image["pro"] === true) && (image["sec"] === "ina")) {
          inaPreview.push(images[j]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === true) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "ani") || (image["sec"] === "pla") || (image["sec"] === "hum") || (image["sec"] === "ina"))
          )) {
          inaPreview.push(images[j]);
        }
      }
    }

    var humPreview = []
    for (var k = 0; k < images.length; k++) {
      let image = images[k];
      if (coaSearchTerm === "") {
        if ((image["pro"] === true) && (image["sec"] === "hum")) {
          humPreview.push(images[k]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === true) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "ani") || (image["sec"] === "pla") || (image["sec"] === "hum") || (image["sec"] === "ina"))
          )) {
          humPreview.push(images[k]);
        }
      }
    }

    var plaPreview = []
    for (var m = 0; m < images.length; m++) {
      let image = images[m];
      if (coaSearchTerm === "") {
        if ((image["pro"] === true) && (image["sec"] === "pla")) {
          plaPreview.push(images[m]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === true) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "ani") || (image["sec"] === "pla") || (image["sec"] === "hum") || (image["sec"] === "ina"))
          )) {
          plaPreview.push(images[m]);
        }
      }
    }

    var previewImages = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if (image["pro"] === true) {
        previewImages.push(images[i]);
      }
    }

    var len = previewImages.length

    function CoaElementsPreview(props) {
      return <div className="coam-info-container">
        <hr />
        <div className="coam-info-head">{props.head || "More Elements with PRO"}</div>
        <div className="coam-info-text">{props.text || len + " extra elements. More coming every month."}</div>
        <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Unlock all elements</span></a></div>
      </div>
    }

    return (
      <div className="coaChargesContainer" style={{ height: "73vh", display: "flex", flexDirection: "column", overflowY: "auto" }}>
        <CoaAdsense></CoaAdsense>
        <div><input className="coaSearchInput" type="text" placeholder="Search Charges" onChange={event => { setSearchTerm(event.target.value) }} /></div>
        <Tabs
          animate={true}
          key={"vertical"}
          vertical={false}
        >
          <Tab id="fan" title="Animals" panel={
            <div style={{ height: "70vh" }}>
              <div>
                <ImagesGrid
                  images={aniImages}
                  getPreview={(image) => image.preview}
                  onSelect={async (image) => {
                    let url = image.url;
                    if (url.search(".svg") === -1) {
                      url = `/wp-content/coamakerbasic/${url}.svg`
                    }
                    image.url = url;
                    const { width, height } = await getImageSize(image.url);
                    store.activePage.addElement({
                      type: "svg",
                      src: image.url,
                      width,
                      height,
                      x: (store.width - width) / 2,
                      y: (store.height - height) / 2.4,
                      name: image.name
                    });
                  }}
                  rowsNumber={4}
                  isLoading={false}
                  loadMore={false}
                />
              </div>
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview></CoaElementsPreview>
                <ImagesGrid
                  images={aniPreview}
                  getPreview={(image) => image.preview}
                  onSelect={async (image) => {
                  }}
                  rowsNumber={4}
                  isLoading={!images.length}
                  loadMore={false}
                />
              </div>
            </div>
          } />
          <Tab id="fpl" title="Plants" panel={
            <div><ImagesGrid
              images={plaImages}
              getPreview={(image) => image.preview}
              onSelect={async (image) => {
                let url = image.url;
                if (url.search(".svg") === -1) {
                  url = `/wp-content/coamakerbasic/${url}.svg`
                }
                image.url = url;
                const { width, height } = await getImageSize(image.url);
                store.activePage.addElement({
                  type: "svg",
                  src: image.url,
                  width,
                  height,
                  x: (store.width - width) / 2,
                  y: (store.height - height) / 2.4,
                  name: image.name
                });
              }}
              rowsNumber={4}
              isLoading={false}
              loadMore={false}
            />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview></CoaElementsPreview>
                <ImagesGrid
                  images={plaPreview}
                  getPreview={(image) => image.preview}
                  onSelect={async (image) => {
                  }}
                  rowsNumber={4}
                  isLoading={!images.length}
                  loadMore={false}
                />
              </div>
            </div>
          } />
          <Tab id="fob" title="Objects" panel={
            <div><ImagesGrid
              images={inaImages}
              getPreview={(image) => image.preview}
              onSelect={async (image) => {
                let url = image.url;
                if (url.search(".svg") === -1) {
                  url = `/wp-content/coamakerbasic/${url}.svg`
                }
                image.url = url;
                const { width, height } = await getImageSize(image.url);
                store.activePage.addElement({
                  type: "svg",
                  src: image.url,
                  width,
                  height,
                  x: (store.width - width) / 2,
                  y: (store.height - height) / 2.4,
                  name: image.name
                });
              }}
              rowsNumber={4}
              isLoading={false}
              loadMore={false}
            />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview></CoaElementsPreview>
                <ImagesGrid
                  images={inaPreview}
                  getPreview={(image) => image.preview}
                  onSelect={async (image) => {
                  }}
                  rowsNumber={4}
                  isLoading={!images.length}
                  loadMore={false}
                />
              </div>
            </div>
          } />
          <Tab id="fhu" title="Humans" panel={
            <div><ImagesGrid
              images={humImages}
              getPreview={(image) => image.preview}
              onSelect={async (image) => {
                let url = image.url;
                if (url.search(".svg") === -1) {
                  url = `/wp-content/coamakerbasic/${url}.svg`
                }
                image.url = url;
                const { width, height } = await getImageSize(image.url);
                store.activePage.addElement({
                  type: "svg",
                  src: image.url,
                  width,
                  height,
                  x: (store.width - width) / 2,
                  y: (store.height - height) / 2.4,
                  name: image.name
                });
              }}
              rowsNumber={4}
              isLoading={false}
              loadMore={false}
            />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview></CoaElementsPreview>
                <ImagesGrid
                  images={humPreview}
                  getPreview={(image) => image.preview}
                  onSelect={async (image) => {
                  }}
                  rowsNumber={4}
                  isLoading={!images.length}
                  loadMore={false}
                />
              </div>
            </div>
          } />
        </Tabs>
      </div>

    );
  }),
};

const TopSection = {
  name: 'top',
  Tab: (props) => (
    <SectionTab name="Exterior" {...props}>
      <FaCrown />
    </SectionTab>
  ),
  // we need observer to update component automatically on any store changes
  Panel: observer(({ store }) => {
    const [images, setImages] = React.useState([]);

    async function loadImages() {
      const time = (new Date()).getTime();
      const animalUrl = "/wp-content/coamakerbasic/coa/0_coa.json?=ver";
      const animalFetch = animalUrl + time;
      fetch(animalFetch)
        .then(function (resp) {
          return resp.json();
        })
        .then(function (data) {
          setImages(data);
        });
      //setImages(data.url);
      await new Promise((resolve) => setTimeout(resolve, 3000));
    }

    React.useEffect(() => {
      loadImages();
    }, []);

    const [coaSearchTerm, setSearchTerm] = useState('');

    var mtlImages = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "mtl")) {
          mtlImages.push(images[i]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "mtl") || (image["sec"] === "cor") || (image["sec"] === "sup") || (image["sec"] === "oth"))
          )) {
          mtlImages.push(images[i]);
        }
      }
    }

    var corImages = []
    for (var j = 0; j < images.length; j++) {
      let image = images[j];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "cor")) {
          corImages.push(images[j]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "mtl") || (image["sec"] === "cor") || (image["sec"] === "sup") || (image["sec"] === "oth"))
          )) {
          corImages.push(images[j]);
        }
      }
    }

    var supImages = []
    for (var k = 0; k < images.length; k++) {
      let image = images[k];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "sup")) {
          supImages.push(images[k]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "mtl") || (image["sec"] === "cor") || (image["sec"] === "sup") || (image["sec"] === "oth"))
          )) {
          supImages.push(images[k]);
        }
      }
    }

    var othImages = []
    for (var m = 0; m < images.length; m++) {
      let image = images[m];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "oth")) {
          othImages.push(images[m]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "mtl") || (image["sec"] === "cor") || (image["sec"] === "sup") || (image["sec"] === "oth"))
          )) {
          othImages.push(images[m]);
        }
      }
    }

    var mtlPreview = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if (coaSearchTerm === "") {
        if ((image["pro"] === true) && (image["sec"] === "mtl")) {
          mtlPreview.push(images[i]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === true) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "mtl") || (image["sec"] === "cor") || (image["sec"] === "sup") || (image["sec"] === "oth"))
          )) {
          mtlPreview.push(images[i]);
        }
      }
    }

    var corPreview = []
    for (var j = 0; j < images.length; j++) {
      let image = images[j];
      if (coaSearchTerm === "") {
        if ((image["pro"] === true) && (image["sec"] === "cor")) {
          corPreview.push(images[j]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === true) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "mtl") || (image["sec"] === "cor") || (image["sec"] === "sup") || (image["sec"] === "oth"))
          )) {
          corPreview.push(images[j]);
        }
      }
    }

    var supPreview = []
    for (var k = 0; k < images.length; k++) {
      let image = images[k];
      if (coaSearchTerm === "") {
        if ((image["pro"] === true) && (image["sec"] === "sup")) {
          supPreview.push(images[k]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === true) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "mtl") || (image["sec"] === "cor") || (image["sec"] === "sup") || (image["sec"] === "oth"))
          )) {
          supPreview.push(images[k]);
        }
      }
    }

    var othPreview = []
    for (var m = 0; m < images.length; m++) {
      let image = images[m];
      if (coaSearchTerm === "") {
        if ((image["pro"] === true) && (image["sec"] === "oth")) {
          othPreview.push(images[m]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === true) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "mtl") || (image["sec"] === "cor") || (image["sec"] === "sup") || (image["sec"] === "oth"))
          )) {
          othPreview.push(images[m]);
        }
      }
    }

    var previewImages = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if (image["pro"] === true) {
        previewImages.push(images[i]);
      }
    }

    var len = previewImages.length

    function CoaElementsPreview(props) {
      return <div className="coam-info-container">
        <hr />
        <div className="coam-info-head">{props.head || "More Elements with PRO"}</div>
        <div className="coam-info-text">{props.text || len + " extra elements. More coming every month."}</div>
        <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Unlock all elements</span></a></div>
      </div>
    }

    return (
      <div className="coaChargesContainer" style={{ height: "73vh", display: "flex", flexDirection: "column", overflowY: "auto" }}>
        <CoaAdsense></CoaAdsense>
        <div><input className="coaSearchInput" type="text" placeholder="Search Charges" onChange={event => { setSearchTerm(event.target.value) }} /></div>
        <Tabs
          animate={true}
          key={"vertical"}
          vertical={false}
        >
          <Tab id="ew" title="Mantles" panel={
            <div>
              <ImagesGrid
                images={mtlImages}
                getPreview={(image) => image.preview}
                onSelect={async (image) => {
                  let url = image.url;
                  if (url.search(".svg") === -1) {
                    url = `/wp-content/coamakerbasic/${url}.svg`
                  }
                  image.url = url;
                  const { width, height } = await getImageSize(image.url);
                  store.activePage.addElement({
                    type: "svg",
                    src: image.url,
                    width,
                    height,
                    x: (store.width - width) / 2,
                    y: (store.height - height) / 2.4,
                    name: image.name
                  });
                }}
                rowsNumber={3}
                isLoading={false}
                loadMore={false}
              />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview></CoaElementsPreview>
                <ImagesGrid
                  images={mtlPreview}
                  getPreview={(image) => image.preview}
                  onSelect={async (image) => {
                  }}
                  rowsNumber={3}
                  isLoading={!images.length}
                  loadMore={false}
                />
              </div>
            </div>
          } />
          <Tab id="dv" title="Crowns" panel={
            <div><ImagesGrid
              images={corImages}
              getPreview={(image) => image.preview}
              onSelect={async (image) => {
                let url = image.url;
                if (url.search(".svg") === -1) {
                  url = `/wp-content/coamakerbasic/${url}.svg`
                }
                image.url = url;
                const { width, height } = await getImageSize(image.url);
                store.activePage.addElement({
                  type: "svg",
                  src: image.url,
                  width,
                  height,
                  x: (store.width - width) / 2,
                  y: (store.height - height) / 2.4,
                  name: image.name
                });
              }}
              rowsNumber={3}
              isLoading={false}
              loadMore={false}
            />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview></CoaElementsPreview>
                <ImagesGrid
                  images={corPreview}
                  getPreview={(image) => image.preview}
                  onSelect={async (image) => {
                  }}
                  rowsNumber={3}
                  isLoading={!images.length}
                  loadMore={false}
                />
              </div>
            </div>
          } />
          <Tab id="pk" title="Supporters" panel={
            <div><ImagesGrid
              images={supImages}
              getPreview={(image) => image.preview}
              onSelect={async (image) => {
                let url = image.url;
                if (url.search(".svg") === -1) {
                  url = `/wp-content/coamakerbasic/${url}.svg`
                }
                image.url = url;
                const { width, height } = await getImageSize(image.url);
                store.activePage.addElement({
                  type: "svg",
                  src: image.url,
                  width,
                  height,
                  x: (store.width - width) / 2,
                  y: (store.height - height) / 2.4,
                  name: image.name
                });
              }}
              rowsNumber={3}
              isLoading={false}
              loadMore={false}
            />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview></CoaElementsPreview>
                <ImagesGrid
                  images={supPreview}
                  getPreview={(image) => image.preview}
                  onSelect={async (image) => {
                  }}
                  rowsNumber={3}
                  isLoading={!images.length}
                  loadMore={false}
                />
              </div>
            </div>
          } />
          <Tab id="pq" title="Other" panel={
            <div><ImagesGrid
              images={othImages}
              getPreview={(image) => image.preview}
              onSelect={async (image) => {
                let url = image.url;
                if (url.search(".svg") === -1) {
                  url = `/wp-content/coamakerbasic/${url}.svg`
                }
                image.url = url;
                const { width, height } = await getImageSize(image.url);
                store.activePage.addElement({
                  type: "svg",
                  src: image.url,
                  width,
                  height,
                  x: (store.width - width) / 2,
                  y: (store.height - height) / 2.4,
                  name: image.name
                });
              }}
              rowsNumber={3}
              isLoading={false}
              loadMore={false}
            />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview></CoaElementsPreview>
                <ImagesGrid
                  images={othPreview}
                  getPreview={(image) => image.preview}
                  onSelect={async (image) => {
                  }}
                  rowsNumber={3}
                  isLoading={!images.length}
                  loadMore={false}
                />
              </div>
            </div>
          } />
        </Tabs>
      </div>

    );
  }),
};

const ShieldSection = {
  name: 'shields',
  Tab: (props) => (
    <SectionTab name="Shields" {...props} >
      <BiShieldQuarter />
    </SectionTab>
  ),
  // we need observer to update component automatically on any store changes
  Panel: observer(({ store }) => {
    const [images, setImages] = React.useState([]);

    async function loadImages() {
      const time = (new Date()).getTime();
      const shieldsUrl = "/wp-content/coamakerbasic/coa/0_coa.json?=ver";
      const shieldFetch = shieldsUrl + time;
      fetch(shieldFetch)
        .then(function (resp) {
          return resp.json();
        })
        .then(function (data) {
          setImages(data);
        });
      //setImages(data.url);
      await new Promise((resolve) => setTimeout(resolve, 3000));
    }

    React.useEffect(() => {
      loadImages();
    }, []);

    var shieldImages = []
    for (var c = 0; c < images.length; c++) {
      let image = images[c];
      if ((image["pro"] === false) && (image["sec"] === "shd")) {
        shieldImages.push(images[c]);
      }
    }

    var lozImages = []
    for (var k = 0; k < images.length; k++) {
      let image = images[k];
      if ((image["pro"] === false) && (image["sec"] === "loz")) {
        lozImages.push(images[k]);
      }
    }

    var bannImages = []
    for (var d = 0; d < images.length; d++) {
      let image = images[d];
      if ((image["pro"] === false) && (image["sec"] === "ban")) {
        bannImages.push(images[d]);
      }
    }

    var previewShields = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if ((image["pro"] === true) && (image["sec"] === "shd")) {
        previewShields.push(images[i]);
      }
    }

    var previewLoz = []
    for (var m = 0; m < images.length; m++) {
      let image = images[m];
      if ((image["pro"] === true) && (image["sec"] === "loz")) {
        previewLoz.push(images[m]);
      }
    }

    var previewBann = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if ((image["pro"] === true) && (image["sec"] === "ban")) {
        previewBann.push(images[i]);
      }
    }

    var roundImages = []
    for (var e = 0; e < images.length; e++) {
      let image = images[e];
      if ((image["pro"] === false) && (image["sec"] === "rnd")) {
        roundImages.push(images[e]);
      }
    }

    var previewRounds = []
    for (var f = 0; f < images.length; f++) {
      let image = images[f];
      if ((image["pro"] === true) && (image["sec"] === "rnd")) {
        previewRounds.push(images[f]);
      }
    }

    var previewImages = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if (image["pro"] === true) {
        previewImages.push(images[i]);
      }
    }

    var len = previewImages.length

    function CoaElementsPreview(props) {
      return <div className="coam-info-container">
        <hr />
        <div className="coam-info-head">{props.head || "More Elements with PRO"}</div>
        <div className="coam-info-text">{props.text || len + " extra elements. More coming every month."}</div>
        <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Unlock all elements</span></a></div>
      </div>
    }

    return (
      <div style={{ height: "100%", display: "flex", flexDirection: "column", overflowY: "auto" }}>
        <CoaAdsense></CoaAdsense>
        <Tabs
          animate={true}
          key={"vertical"}
          vertical={false}
        >
          <Tab id="fsi" title="Shields" panel={
            <div><ImagesGrid
              images={shieldImages}
              getPreview={(image) => image.preview}
              onSelect={async (image) => {
                let url = image.url;
                if (url.search(".svg") === -1) {
                  url = `/wp-content/coamakerbasic/${url}.svg`
                }
                image.url = url;
                const { width, height } = await getImageSize(image.url);
                store.activePage.addElement({
                  type: "svg",
                  src: image.url,
                  width,
                  height,
                  x: (store.width - width) / 2,
                  y: (store.height - height) / 2.4,
                  name: image.name
                });
              }}
              rowsNumber={4}
              isLoading={false}
              loadMore={false}
            />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview text="Use the full potential of our family crest maker, sigil maker, and heraldry studio. Make your coat of arms with hundreds of elements. Use our coat of arms templates."></CoaElementsPreview>
                <ImagesGrid
                  images={previewShields}
                  getPreview={(image) => image.preview}
                  onSelect={async (image) => {
                  }}
                  rowsNumber={4}
                  isLoading={!images.length}
                  loadMore={false}
                />
              </div>
            </div>
          } />
          <Tab id="flt" title="Lozenges" panel={
            <div><ImagesGrid
              images={lozImages}
              getPreview={(image) => image.preview}
              onSelect={async (image) => {
                let url = image.url;
                if (url.search(".svg") === -1) {
                  url = `/wp-content/coamakerbasic/${url}.svg`
                }
                image.url = url;
                const { width, height } = await getImageSize(image.url);
                store.activePage.addElement({
                  type: "svg",
                  src: image.url,
                  width,
                  height,
                  x: (store.width - width) / 2,
                  y: (store.height - height) / 2.4,
                  name: image.name
                });
              }}
              rowsNumber={4}
              isLoading={false}
              loadMore={false}
            />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview text="Create lozenge and diamond shaped coat of arms for classical designs for women in heraldry or emblems and sigils."></CoaElementsPreview>
                <ImagesGrid
                  images={previewLoz}
                  getPreview={(image) => image.preview}
                  onSelect={async (image) => {
                  }}
                  rowsNumber={4}
                  isLoading={!images.length}
                  loadMore={false}
                />
              </div>
            </div>
          } />
          <Tab id="frd" title="Rounds" panel={
            <div><ImagesGrid
              images={roundImages}
              getPreview={(image) => image.preview}
              onSelect={async (image) => {
                let url = image.url;
                if (url.search(".svg") === -1) {
                  url = `/wp-content/coamakerbasic/${url}.svg`
                }
                image.url = url;
                const { width, height } = await getImageSize(image.url);
                store.activePage.addElement({
                  type: "svg",
                  src: image.url,
                  width,
                  height,
                  x: (store.width - width) / 2,
                  y: (store.height - height) / 2.4,
                  name: image.name
                });
              }}
              rowsNumber={3}
              isLoading={false}
              loadMore={false}
            />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview head="More Round Templates with PRO" text="Emblem, Coin, and Sigil Maker: Create coins, Japanese mon emblems, Viking shields, and artwork for worlbuilding projects."></CoaElementsPreview>
                <ImagesGrid
                  images={previewRounds}
                  getPreview={(image) => image.preview}
                  onSelect={async (image) => {
                  }}
                  rowsNumber={3}
                  isLoading={!images.length}
                  loadMore={false}
                />
              </div>
            </div>
          } />
          <Tab id="fbr" title="Flags" panel={
            <div><ImagesGrid
              images={bannImages}
              getPreview={(image) => image.preview}
              onSelect={async (image) => {
                let url = image.url;
                if (url.search(".svg") === -1) {
                  url = `/wp-content/coamakerbasic/${url}.svg`
                }
                image.url = url;
                const { width, height } = await getImageSize(image.url);
                store.activePage.addElement({
                  type: "svg",
                  src: image.url,
                  width,
                  height,
                  x: (store.width - width) / 2,
                  y: (store.height - height) / 2.4,
                  name: image.name
                });
              }}
              rowsNumber={3}
              isLoading={false}
              loadMore={false}
            />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview head="More Flags & Banners with PRO" text="Flag Maker: Make your own flag with the flag templates in our generator. Design country and fantasy flags in medieval style with our vexillology and banner creator."></CoaElementsPreview>
                <ImagesGrid
                  images={previewBann}
                  getPreview={(image) => image.preview}
                  onSelect={async (image) => {
                  }}
                  rowsNumber={3}
                  isLoading={!images.length}
                  loadMore={false}
                />
              </div>
            </div>
          } />
        </Tabs>

      </div >
    );
  }),
};


const TemplatesPanel = observer(({ store }) => {

  return (
    <div style={{ height: '100%' }} className="coa-template-container">
      <h4>Templates are a PRO feature</h4>
      <div className="coam-promotion-panel">Use pre-arranged templates to create your complex coat of arms quickly.</div>
      <div className="coam-promotion-panel">Switch colors and elements quickly.</div>
      <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Learn more</span></a></div>
      <div><img src="/wp-content/coamakerbasic/templates/Templates_Preview.jpg" width="100%" /></div>
    </div>
  );
});

const TemplatesSection = {
  name: 'custom-templates',
  Tab: (props) => (
    <SectionTab name="Templates" {...props}>
      <FaFileImport />
    </SectionTab>

  ),
  // we need observer to update component automatically on any store changes
  Panel: TemplatesPanel,
};


const ToolPanel = observer(({ store }) => {

  return (
    <div className="coaChargesContainer" style={{ height: "73vh", display: "flex", flexDirection: "column", overflowY: "auto" }}>
      <CoaAdsense></CoaAdsense>
      <Tabs
        animate={true}
        key={"vertical"}
        vertical={false}
      >
        <Tab id="fsz" title="Format" panel={
          <div>
            <div>
              {AVAILABLE_SIZES.map(({ width, height, format }, i) => (
                <Button
                  key={i}
                  style={{ width: "100%", marginBottom: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}
                  onClick={() => {
                    store.setSize(width, height, true);
                    store.deleteElements(["logo"]);
                    store.activePage.addElement({
                      type: "svg",
                      src: "/wp-content/coamakerbasic/coageneral/coamaker-main-logo.svg",
                      height: height / 1080 * 100,
                      width: height / 1080 * 201,
                      x: height / 1080 * 25,
                      y: height - height / 1080 * 25 - height / 1080 * 100,
                      name: "CoaMaker Logo",
                      locked: true,
                      selectable: false,
                      alwaysOnTop: true,
                      id: "logo"
                    });
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>{format} </span>
                  <span>{`${width} x ${height}`}</span>
                </Button>
              ))}
            </div>
            <div style={{ marginTop: "25px" }}>
              <h4>More sizes with PRO</h4>
              <div className="coam-promotion-panel">With a PRO account, you can use US letter and European A4 sizes. You can also set custom sizes.</div>
              <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Learn more</span></a></div>
            </div>
          </div>
        } />
        <Tab id="fup" title="Upload" panel={
          <div>
            <h4>Uploads are a PRO feature</h4>
            <div className="coam-promotion-panel">Do you want to upload your own elements?</div>
            <div className="coam-promotion-panel">With a PRO account you can add every image file you want to your design.</div>
            <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Learn more</span></a></div>
          </div>
        } />
        <Tab id="ftx" title="Text" panel={
          <div>
            <h4>Add Text is a PRO feature</h4>
            <div className="coam-promotion-panel">Add family names, realms names, and mottos above, below, or on your shield.</div>
            <div className="coam-promotion-panel">Use carefully selected fonts or switch to dozens of others.</div>
            <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Learn more</span></a></div>
            <div><img src="/wp-content/coamakerbasic/fonts/Text_Preview.jpg" width="100%" /></div>
          </div>
        } />
        <Tab id="ftp" title="Templates" panel={
          <div>
            <h4>Templates are a PRO feature</h4>
            <div className="coam-promotion-panel">Use pre-arranged templates to create your complex coat of arms quickly.</div>
            <div className="coam-promotion-panel">Switch colors and elements quickly.</div>
            <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Learn more</span></a></div>
            <div><img src="/wp-content/coamakerbasic/templates/Templates_Preview.jpg" width="100%" /></div>
          </div>
        } />
      </Tabs>
    </div>
  );
});

const ToolSection = {
  name: 'tools',
  Tab: (props) => (
    <SectionTab name="Tools" {...props}>
      <Icon iconSize={20} icon="build" />
    </SectionTab>

  ),
  // we need observer to update component automatically on any store changes
  Panel: ToolPanel,
};

const dntTutorials = [
  { title: "How to Adjust Colors", videoId: "pTN3BYDpv6A" },
  { title: "How to Use Layers", videoId: "DAlWDPMvEFk" },
  { title: "How to Save Designs (PRO)", videoId: "L_UPW_Fd7to" }
];

const HelpPanel = observer(({ store }) => {

  return (
    <div className="coaChargesContainer" style={{ height: "73vh", display: "flex", flexDirection: "column", overflowY: "auto" }}>
      {/* Map through videos array to render a TutorialModal for each video */}
      {dntTutorials.map((video, index) => (
        <TutorialModal key={index} title={video.title} videoId={video.videoId} />
      ))}
      <div className="coam-promotion-panel">As a PRO user, you can save your designs and export them in higher quality with transparent background.</div>
      <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Learn more</span></a></div>
    </div>
  );
});

const HelpSection = {
  name: 'prints',
  Tab: (props) => (
    <SectionTab name="Tutorial" {...props}>
      <Icon iconSize={20} icon="learning" />
    </SectionTab>

  ),
  // we need observer to update component automatically on any store changes
  Panel: HelpPanel,
};

const SavePanel = observer(({ store }) => {

  return (
    <div style={{ height: '100%' }}>
      <h4>Saving is a PRO feature</h4>
      <div className="coam-promotion-panel">With a PRO account, you can save a design to your desk and upload it later again to continue editing and refining it.</div>
      <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Learn more</span></a></div>
    </div>
  );
});

const SaveSection = {
  name: 'custom-save',
  Tab: (props) => (
    <SectionTab name="Save" {...props}>
      <Icon iconSize={20} icon="floppy-disk" />
    </SectionTab>

  ),
  // we need observer to update component automatically on any store changes
  Panel: SavePanel,
};


const sections = [
  LayersSection,
  ShieldSection,
  AnimalSection,
  TopSection,
  ToolSection,
  SaveSection,
  HelpSection
];

export const App = () => {
  const inputRef = React.useRef();

  return (

    <div
      style={{
        display: "flex",
        height: "90vh",
        width: "100%"
      }}
    >

      <PolotnoContainer className="polotno-app-container">

        <SidePanelWrap className="pro-side-panel">
          <NavbarContainer className="bp3-navbar coam-navbar-promo" >
            <NavInner>
              <Navbar.Group align={Alignment.LEFT} className="coam-navbar-promo-left">
                <div className="coam-promotion-top">"I checked out other generators, but this is the most fun to use – mostly because of the well-selected artwork." – Gerit W.
                </div>
              </Navbar.Group>
              <Navbar.Group align={Alignment.RIGHT} className="coam-navbar-promo-right">
                <div className="coam-sub-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-sub-button">Learn more</span></a></div>
              </Navbar.Group>
            </NavInner>
          </NavbarContainer>
          <SidePanel store={store} sections={sections} defaultSection="shields" />
        </SidePanelWrap>
        <WorkspaceWrap>
          <Toolbar store={store} downloadButtonEnabled={true} hideSvgEffects={true} hideOpacity={true}>
          </Toolbar>

          <Workspace store={store} backgroundColor="#f5f0e2" pageControlsEnabled={false} />
          <ZoomButtons store={store} />
        </WorkspaceWrap>
      </PolotnoContainer>
    </div>

  );
};



ReactDOM.render(<App />, document.getElementById("root"));

export default App;